import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigAssetLoaderService } from '../config/config-asset-loader.service';
import { MenuItems } from './model/menu-items.model';
import { InterceptorSkipHeader } from '../interceptor/interceptor.constants';
import { withCache } from '@ngneat/cashew';

@Injectable({
  providedIn: 'root',
})
export class MenuApiService {
  MENU_API_BASE_URL: string;

  constructor(
    private httpClient: HttpClient,
    //@Inject('apiBaseUrl') private apiBaseUrl: string,
    private configService: ConfigAssetLoaderService
  ) {
    this.MENU_API_BASE_URL = configService.getConfig().apiBaseUrl + 'site/menu';
  }

  getMenuItems(id: string): Observable<MenuItems> {
    return this.httpClient.get<MenuItems>(
      this.MENU_API_BASE_URL + '?format=json',
      {
        ...InterceptorSkipHeader,
        context: withCache({
          version: 'v1',
          key: 'menuItems-' + id,
        }),
      }
    );
  }

  getServiceSubMenuItems(id: string): Observable<MenuItems> {
    return this.httpClient.get<MenuItems>(
      this.MENU_API_BASE_URL + '/submenu?format=json',
      {
        ...InterceptorSkipHeader,
        context: withCache({
          version: 'v1',
          key: 'submenu-' + id,
        }),
      }
    );
  }
}
